import React from "react";
import TextField from '@mui/material/TextField';
import { PokemonListContext } from "../context/pokemonContext";
import { setFilter } from "../actions/pokemon";

const Header = () => {

    const { filters, dispatchFilters } = React.useContext(PokemonListContext);

    return (
        <div className="header">
            <div className="container d-flex flex-row justify-content-between align-items-center">
        
            <h1 className="header-heading">
                <img src="./images/pokeball.png" alt="pokedex" className="header-img img-fluid" />
                &nbsp; Pokedex
            </h1>

            <div className="search-field">

                <TextField 
                    id="standard-basic" 
                    label="Search" 
                    variant="standard"
                    value={filters.filter}
                    autoComplete="off"
                    onChange={(e) => {
                        dispatchFilters(setFilter(e.target.value));
                    }}
                />
            </div>
            </div>
        </div>
    );
};

export default Header;